<script setup>
import { ref, computed } from "vue";
import useActionButtonsCommon from "@/composables/ActionButtonsCommon";

const { store, loading, _error, selectedDevices } = useActionButtonsCommon();

const currentUser = computed(() => store.getters["auth/getUsername"]);

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(["update:modelValue"]);

const command = ref("");

const closeModal = () => {
  _error.value = null;
  emit("update:modelValue", false);
  resetForm();
};

const sendCommand = async () => {
  if (command.value.trim()) {
    const payload = {
      commands: command.value,
      imeis: selectedDevices.value.map((s) => s.imei),
      user: currentUser.value,
    };
    try {
      loading.value = true;
      await store.dispatch("devices/sendCommands", payload);
      store.dispatch("toastNotification/displayToast", {
        message: "Commands sent",
        type: "success",
      });
      loading.value = false;

      closeModal();
    } catch (error) {
      loading.value = false;
      _error.value = error?.message || "Failed to send commands";
    }
  }
};

const resetForm = () => {
  command.value = "";
};
</script>

<template>
  <div v-if="modelValue">
    <div class="modal fade show d-block" tabindex="-1" role="dialog">
      <div class="modal-backdrop fade show" @click="closeModal"></div>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Command list</h4>
            <button type="button" class="close" @click="closeModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <p>
              Send command{{ selectedDevices.length > 1 ? "s" : "" }} to
              {{ selectedDevices.length }} device{{
                selectedDevices.length > 1 ? "s" : ""
              }}
            </p>
            <div class="form-group">
              <textarea
                class="form-control bg-white"
                rows="10"
                v-model="command"
                placeholder="Enter your command here..."
              ></textarea>
            </div>
            <p v-if="_error" class="text-danger">{{ _error }}</p>
          </div>

          <div class="modal-footer justify-content-end">
            <button type="button" class="btn btn-danger" @click="closeModal">
              CLOSE
            </button>
            <button
              v-if="!loading"
              type="button"
              class="btn btn-success"
              @click="sendCommand"
              :disabled="!command.trim()"
            >
              SEND
            </button>
            <div
              class="justify-content-center align-items-center"
              style="text-align: center"
            >
              <font-awesome-icon
                v-if="loading"
                :icon="['fas', 'spinner']"
                spin
                size="2x"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "@/styles/modal.css";

.form-control {
  resize: none;
}
</style>
